import { useState, useEffect } from "react";
import { useAdmin } from "@/contexts/AdminContext";
import { Link } from "react-router-dom";
import { FileText, Users, MapPin, Globe, Mail, Settings } from "lucide-react";

export default function AdminDashboard() {
  const { api } = useAdmin();
  const [stats, setStats] = useState({ insights: 0, team: 0, addresses: 0, contacts: 0, pages: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [insRes, teamRes, addrRes, contRes, pgRes] = await Promise.all([
          api.get("/admin/insights"),
          api.get("/admin/team"),
          api.get("/addresses"),
          api.get("/admin/contacts"),
          api.get("/pages"),
        ]);
        setStats({
          insights: insRes.data.length,
          team: teamRes.data.length,
          addresses: addrRes.data.length,
          contacts: contRes.data.length,
          pages: pgRes.data.length,
        });
      } catch (e) { console.error("Dashboard stats error:", e); }
    };
    fetchStats();
  }, [api]);

  const cards = [
    { label: "Pages", count: stats.pages, icon: Globe, link: "/admin/pages", color: "bg-blue-50 text-blue-600" },
    { label: "Team Members", count: stats.team, icon: Users, link: "/admin/team", color: "bg-emerald-50 text-emerald-600" },
    { label: "Insights", count: stats.insights, icon: FileText, link: "/admin/insights", color: "bg-amber-50 text-amber-600" },
    { label: "Addresses", count: stats.addresses, icon: MapPin, link: "/admin/addresses", color: "bg-purple-50 text-purple-600" },
    { label: "Contact Submissions", count: stats.contacts, icon: Mail, link: "/admin/contacts", color: "bg-rose-50 text-rose-600" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl text-[#0A1628] font-medium mb-8">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(c => (
          <Link key={c.label} to={c.link} data-testid={`dashboard-card-${c.label.toLowerCase().replace(/\s+/g, '-')}`} className="bg-white border border-slate-200 p-6 rounded-[2px] hover:border-[#0A1628] transition-colors group">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 rounded-[2px] flex items-center justify-center ${c.color}`}>
                <c.icon size={18} />
              </div>
              <span className="text-3xl font-heading font-medium text-[#0A1628]">{c.count}</span>
            </div>
            <p className="text-slate-500 text-sm">{c.label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-[2px]">
        <h2 className="font-heading text-lg text-[#0A1628] mb-4">Quick Actions</h2>
        <div className="flex flex-wrap gap-3">
          <Link to="/admin/insights?new=true" className="bg-[#0A1628] text-white text-xs px-4 py-2 uppercase tracking-wider hover:bg-[#1a2c4e] rounded-[2px]">New Insight</Link>
          <Link to="/admin/team?new=true" className="bg-[#0A1628] text-white text-xs px-4 py-2 uppercase tracking-wider hover:bg-[#1a2c4e] rounded-[2px]">New Team Member</Link>
          <Link to="/admin/settings" className="border border-slate-200 text-slate-600 text-xs px-4 py-2 uppercase tracking-wider hover:border-[#0A1628] rounded-[2px]">Edit Settings</Link>
        </div>
      </div>
    </div>
  );
}
